module.exports = __webpack_public_path__ + "static/media/cart-light-theme.23276bb8.svg";